export function getError(errors, path) {
  if (!errors) return null;

  const value = errors[path];

  if (Array.isArray(value)) return value[0];
  if (typeof value === "string") return value;

  return null;
}